import { VIEW_USER_DETAILS, PROFILE_DETAILS } from './types'

const viewDetails = payload => ({ type: VIEW_USER_DETAILS, payload })
const profileDetails = payload => ({ type: PROFILE_DETAILS, payload })

export { viewDetails, profileDetails }
